"use client";

import Ticker from "react-ticker";
import Image from "next/image";
import { useRef } from "react";

const PartnerImage = ({ name }: { name: string }) => {
  const isCompfest = name === "compfest";
  return (
    <div
      className="w-full mx-3 mt-2 relative"
      style={{
        height: 50,
        width: 100,
      }}
    >
      <Image
        unoptimized
        className="object-contain object-center w-full h-full"
        id={`partnerlogo-${name}`}
        src={`/images/speaking/${name}.png`}
        alt={`Partner Logo - ${name}`}
        key={`image-number-${name}`}
        fill
        style={{
          filter: isCompfest ? "invert(1)" : "none",
        }}
      />
    </div>
  );
};

const PlacesMarquee = () => {
  const PartnersList = useRef([
    "adplist",
    "ui",
    "compfest",
    "fmipa",
    "goto",
    "telu",
    "tokopedia",
    "gdsc",
    "fasilkom",
  ]);

  return (
    <div className="w-full relative">
      <h2 className="text-2xl mb-2 font-bold font-secondary">
        Places I&apos;ve spoken at:
      </h2>
      <div className="lg:block">
        <Ticker speed={6}>
          {(_) => (
            <div className="flex flex-row items-center overflow-hidden ticker">
              {PartnersList.current.map((partner, index) => (
                <PartnerImage name={partner} key={index} />
              ))}
            </div>
          )}
        </Ticker>
      </div>
    </div>
  );
};

export default PlacesMarquee;
